module.exports = __webpack_public_path__ + "media/images/rivile_logo-c6667648.svg";